export const buildSmallIconSize = (FOUNDATIONS) => ({
    icon: {
        height: FOUNDATIONS.size_300,
        width: FOUNDATIONS.size_300,
    },
});
//# sourceMappingURL=small.js.map